export const GET_LISTINGS_FOR_DEALER_API_REQUEST = "GET_LISTINGS_FOR_DEALER_API_REQUEST";
export const GET_LISTINGS_FOR_DEALER_API_SUCCESS = "GET_LISTINGS_FOR_DEALER_API_SUCCESS";
export const GET_LISTINGS_FOR_DEALER_API_ERROR = "GET_LISTINGS_FOR_DEALER_API_ERROR";

export const EDIT_CURRENT_SELECTED_LISTING = "EDIT_CURRENT_SELECTED_LISTING";

export const GET_LISTING_SYNC_ERRORS_API_REQUEST = "GET_LISTING_SYNC_ERRORS_API_REQUEST";
export const GET_LISTING_SYNC_ERRORS_API_SUCCESS = "GET_LISTING_SYNC_ERRORS_API_SUCCESS";
export const GET_LISTING_SYNC_ERRORS_API_ERROR = "GET_LISTING_SYNC_ERRORS_API_ERROR";

export const GET_DEALER_LISTINGS_WITH_ERRORS_API_REQUEST = "GET_DEALER_LISTINGS_WITH_ERRORS_API_REQUEST";
export const GET_DEALER_LISTINGS_WITH_ERRORS_API_SUCCESS = "GET_DEALER_LISTINGS_WITH_ERRORS_API_SUCCESS";
export const GET_DEALER_LISTINGS_WITH_ERRORS_API_ERROR = "GET_DEALER_LISTINGS_WITH_ERRORS_API_ERROR";

export const GET_LISTINGS_CHANGES_API_REQUEST = "GET_LISTINGS_CHANGES_API_REQUEST";
export const GET_LISTINGS_CHANGES_API_SUCCESS = "GET_LISTINGS_CHANGES_API_SUCCESS";
export const GET_LISTINGS_CHANGES_API_ERROR = "GET_LISTINGS_CHANGES_API_ERROR";

export const USECHATMETERLOCATION_API_REQUEST = "USECHATMETERLOCATION_API_REQUEST";
export const USECHATMETERLOCATION_API_SUCCESS = "USECHATMETERLOCATION_API_SUCCESS";
export const USECHATMETERLOCATION_API_ERROR = "USECHATMETERLOCATION_API_ERROR";

export const GET_LMVALIDATION_API_REQUEST = "GET_LMVALIDATION_API_REQUEST";
export const GET_LMVALIDATION_API_SUCCESS = "GET_LMVALIDATION_API_SUCCESS";
export const GET_LMVALIDATION_API_ERROR = "GET_LMVALIDATION_API_ERROR";
